import { ThemeLayout } from '../../front/lib/ThemeLayout';
import { createApp } from 'vue';
import SiteSearch from '../../front/components/SiteSearch/SiteSearch.vue';
import { theme } from '../../front/Theme';
export class FailedResponse extends ThemeLayout {
    init() {
        const searchAppEl = this.getElementById('searchApp');
        if (searchAppEl) {
            this.initSearchApp(searchAppEl);
        }
    }
    initSearchApp(rootEl) {
        var _a, _b;
        const localeIgnoreList = ((_b = (_a = theme().json.i18n) === null || _a === void 0 ? void 0 : _a.availableLocales) === null || _b === void 0 ? void 0 : _b.flatMap(locale => Object.values(locale))) || [];
        const pathArr = window.location.pathname.split(/\W/iu).filter(s => s && !localeIgnoreList.includes(s));
        const query = pathArr.join(' ');
        const app = createApp(SiteSearch, {
            query,
            initialMatchingStrategy: 'last',
        });
        app.use(theme().i18n);
        const appInstance = app.mount(rootEl);
    }
}
